module.exports = __webpack_public_path__ + "static/media/Team 18 - The Collaborators.5e297e0b.png";